export const titleCase = (text: string): string =>
  text
    .split('_')
    .reduce((acc, item) => {
      if (item.length) {
        acc = `${acc} ${item[0]?.toUpperCase() + item.slice(1).toLowerCase()}`;
      }
      return acc;
    }, '')
    .trimStart();
